module.exports = __webpack_public_path__ + "static/media/placeholder.664d49e3.png";